import React from 'react'
import PropTypes from 'prop-types'
import raf from 'raf'
// https://gist.github.com/brthornbury/27531e4616b68131e512fc622a61baba

export default class AtTopProp extends React.PureComponent {
  static propTypes = {  // eslint-disable-line no-undef
    margin: PropTypes.number
  }

  static defaultProps = {  // eslint-disable-line no-undef
    margin: 50
  }

  state = { atTop: true }  // eslint-disable-line no-undef
  handlingScrollUpdate = false  // eslint-disable-line no-undef

  getScrollY = () => {  // eslint-disable-line no-undef
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset
    } else if (window.scrollTop !== undefined) {
      return window.scrollTop
    } else {
      return (document.documentElement || document.body.parentNode || document.body).scrollTop
    }
  }

  handleScroll = () => {  // eslint-disable-line no-undef
    if (!this.handlingScrollUpdate) {
      this.handlingScrollUpdate = true
      raf(this.update)
    }
  }

  update = () => {  // eslint-disable-line no-undef
    let currentScrollY = this.getScrollY()
    this.setState({
      atTop: currentScrollY < this.props.margin
    })

    this.handlingScrollUpdate = false
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  render () {
    const { children, ...rest } = this.props
    return <div>{React.cloneElement(children, Object.assign({atTop: this.state.atTop}, rest))}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/at-top-prop.js